
import React from 'react';
import { Card } from '../../../components/base/Card';

export const AboutSection: React.FC = () => {
  const values = [
    {
      icon: 'ri-target-line',
      title: 'Enfoque Estratégico',
      description: 'Desarrollamos estrategias personalizadas basadas en análisis profundo de tu industria y mercado.'
    },
    {
      icon: 'ri-team-line',
      title: 'Experiencia Comprobada',
      description: 'Más de 15 años transformando empresas de todos los tamaños en diversos sectores industriales.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Resultados Medibles',
      description: 'Implementamos KPIs claros y sistemas de seguimiento para garantizar el éxito de cada proyecto.'
    },
    {
      icon: 'ri-handshake-line',
      title: 'Compromiso Total',
      description: 'Trabajamos como socios estratégicos, comprometidos con el crecimiento sostenible de tu empresa.'
    }
  ];

  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Transformamos Empresas con 
              <span className="text-blue-600"> Estrategia Inteligente</span>
            </h3>
            <p className="text-lg text-gray-600 mb-8">
              En Spirits Business LLC, creemos que cada empresa tiene un potencial único por descubrir. 
              Nuestro enfoque combina análisis riguroso, estrategia innovadora y ejecución práctica 
              para generar resultados tangibles y sostenibles.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Hemos ayudado a más de 500 empresas a optimizar sus operaciones, desarrollar nuevas 
              estrategias de crecimiento y navegar exitosamente los desafíos del mercado actual.
            </p>
            
            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div className="text-3xl font-bold text-blue-600 mb-1">500+</div>
                <div className="text-gray-600">Proyectos Exitosos</div>
              </div>
              <div className="text-center p-4 bg-green-50 rounded-lg">
                <div className="text-3xl font-bold text-green-600 mb-1">85%</div>
                <div className="text-gray-600">Crecimiento Promedio</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/ab47957d1874eeb6cbdaf4126fb9c32a.jpg"
              alt="Equipo de consultoría estratégica Spirits Business LLC"
              className="w-full h-96 lg:h-[500px] object-cover object-top rounded-2xl shadow-xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Certificados</div>
                  <div className="text-gray-600 text-sm">ISO 9001 & PMI</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="mt-20">
          <h4 className="text-3xl font-bold text-center text-gray-900 mb-12">¿Por Qué Elegirnos?</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <Card key={index} className="text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-2xl text-blue-600`}></i>
                </div>
                <h5 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h5>
                <p className="text-gray-600">{value.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
